<script>
import '@telexpress_auth/vue-mbc/dist/components/GroupCustomerList.css';
import GroupCustomerList from '@telexpress_auth/vue-mbc/dist/components/GroupCustomerList.umd.min';

export default GroupCustomerList;
</script>
